import React from "react";
import { inject, observer } from "mobx-react";

const DonationList = (props) => {
  const { donations, rewards, rewardSort, targets, targetsSort } =
    props.overlayStore;
  const url = `${process.env.REACT_APP_LOCAL_URI}`;
  let streamerType = window.location.href.replace(url, "").split("/")[2];

  const queryString = window.location.search;

  const urlParams = new URLSearchParams(queryString);
  const textColor = urlParams.get("textColor")
    ? urlParams.get("textColor")
    : props.findParam("textColor");
  const donorShow = urlParams.get("donors")
    ? urlParams.get("donors")
    : props.findParam("donors");
  const rewardsShow = urlParams.get("rewards")
    ? urlParams.get("rewards")
    : props.findParam("rewards");
  const challengesShow = urlParams.get("targets")
    ? urlParams.get("targets")
    : props.findParam("targets");

  const addZeroes = (num) => {
    let value = num;
    const res = String(num).split(".");
    if (res.length === 1 || res[1].length <= 3) {
      value = value.toFixed(2).replace(/\.00$/, "");
    }
    return value;
  };

  const convertTwitchAmount = (amount, decPlaces) => {
    return parseInt(amount.toString().slice(0, -decPlaces));
  };

  return (
    <div className="donor-list">
      <div className="fade-left"></div>
      <div className="fade-right"></div>
      <div className="marquee-wrap">
        <div className="scroller">
          {donations.length && donorShow === "yes" ? (
            <ul id="donors">
              <li className="recent-dono">Recent Donations</li>
              {donations
                .slice()
                .reverse()
                .map((donation) => (
                  <li key={donation.id}>
                    <strong>
                      {streamerType !== "twitch"
                        ? donation.donor_name
                        : donation.user_name}
                    </strong>{" "}
                    <span
                      className={`
                      donation-amount
                      ${textColor}`}
                    >
                      $
                      {streamerType !== "twitch"
                        ? addZeroes(Number(donation.amount.value))
                        : convertTwitchAmount(donation.amount.value, 2)}
                    </span>
                  </li>
                ))}
            </ul>
          ) : (
            ""
          )}
          {rewards.length > 0 && rewardsShow === "yes" && (
            <ul id="rewards">
              {rewards.filter(({ active }) => active).length > 0 && (
                <li className="recent-dono">Rewards</li>
              )}
              {rewardSort.map(
                (reward) =>
                  reward.active === true && (
                    <li key={reward.id}>
                      <strong>{reward.name}</strong>{" "}
                      <span
                        className={`
                              donation-amount
                              ${textColor}`}
                      >
                        ${addZeroes(Number(reward.amount.value))}
                      </span>{" "}
                    </li>
                  )
              )}
            </ul>
          )}
          {targets.length > 0 && challengesShow === "yes" && (
            <ul id="challenges">
              {targets.filter(({ active }) => active).length > 0 && (
                <li className="recent-dono">Targets</li>
              )}
              {targetsSort.map(
                (target) =>
                  target.active === true && (
                    <li key={target.id}>
                      <strong>{target.name}</strong>{" "}
                      <span
                        className={`
                              donation-amount
                              ${textColor}`}
                      >
                        ${addZeroes(Number(target.amount.value))}
                      </span>{" "}
                    </li>
                  )
              )}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default inject("overlayStore")(observer(DonationList));
